import React from 'react'
import PropTypes from 'prop-types'
import { flags, useFeatureFlags } from 'lib/feature-flags'
import SeasonalLogoFrame from './seasonal-logo-frame'

const FlaggedSeasonalLogo = ({ now, children }) => {
  const [isEnabled] = useFeatureFlags([flags.FLAG_FEAT_COACH_SEASONAL_LOGO])

  return (
    <SeasonalLogoFrame enabled={isEnabled === true} now={now}>
      {children}
    </SeasonalLogoFrame>
  )
}

/**
 * Layers a short seasonal particle animation over the logo (not a different
 * logo image). It plays on its own at most every 30 minutes per browser, and
 * again while the logo is hovered or tapped.
 *
 * Opt-in per brand via `enabled` (the logo config's `seasonalOverlay`), then
 * gated by the Flagr flag. Brands that do not opt in render only `children`.
 * Once opted in the wrapper stays mounted while the flag loads or is off, so
 * the logo element is never re-created.
 */
const SeasonalLogo = ({ enabled = false, now, children }) =>
  enabled ? (
    <FlaggedSeasonalLogo now={now}>{children}</FlaggedSeasonalLogo>
  ) : (
    children
  )

SeasonalLogo.propTypes = {
  enabled: PropTypes.bool,
  now: PropTypes.instanceOf(Date),
  children: PropTypes.node.isRequired,
}

export { getSeason, SEASONS } from './seasons'
export { resetAutoPlayDecision, clearAutoPlayHistory } from './auto-play'
export default SeasonalLogo
